import type { Application } from '@hotwired/stimulus';
import { Controller } from '@hotwired/stimulus';

/**
 * Adds clipboard functionality to element
 */
export class ClipboardController extends Controller<HTMLElement> {
    static register(application: Application) {
        application.register('clipboard', this);
    }

    /**
     * Prevent any default event and copy `data-copy-target`-value to clipboard.
     * @param event The original event
     */
    copy(event: MouseEvent) {
        event.preventDefault();
        navigator.clipboard.writeText(event.params.copyTarget);
    }
}